import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router'
import { useSesion } from '@/datos/sesion'
import { superficieDe, type Rol } from '@/lib/permisos'
import { Cargando } from './Cargando'
import { SinAcceso } from '@/superficies/acceso/SinAcceso'

/**
 * Deja pasar solo a los roles indicados. Es comodidad de navegación: la
 * seguridad real está en la base (RLS). Admin entra a todas las superficies.
 */
export function RutaProtegida({ roles, children }: { roles: readonly Rol[]; children: ReactNode }) {
  const { cargando, sesion, perfil } = useSesion()
  const ubicacion = useLocation()
  if (cargando) return <Cargando />
  if (!sesion) {
    const volver = encodeURIComponent(ubicacion.pathname + ubicacion.search)
    return <Navigate to={`/entrar?volver=${volver}`} replace />
  }
  if (!perfil || !perfil.activo) return <SinAcceso />
  if (perfil.rol !== 'admin' && !roles.includes(perfil.rol)) {
    return <Navigate to={superficieDe(perfil.rol)} replace />
  }
  return <>{children}</>
}

/** La raíz manda a cada quien a su superficie. */
export function InicioPorRol() {
  const { cargando, sesion, perfil } = useSesion()
  if (cargando) return <Cargando />
  if (!sesion) return <Navigate to="/entrar" replace />
  if (!perfil || !perfil.activo) return <SinAcceso />
  return <Navigate to={superficieDe(perfil.rol)} replace />
}
